
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-buy/designer-bag-buyers/Spacer",
      function () {
        return require("private-next-pages/what-we-buy/designer-bag-buyers/Spacer.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-buy/designer-bag-buyers/Spacer"])
      });
    }
  